import {useNavigate} from "react-router-dom";
import {ALL_ACCESS_ROLE_ID, COMMERCIAL_ROLE_ID, COMPTABLE_ROLE_ID} from "./constants";
import {useContext} from "react";
import AuthContext from "../components/shared/AuthContext";

export const useAuthHelper = () => {
    const navigate = useNavigate();
    const {user} = useContext(AuthContext);
const {userAcces} = useContext(AuthContext);
    /**
     * the component/route when this func is called have only admin access. (parent_id===0)
     */
    const onlyAdmins = () => {
        if(user===undefined || user===null){
            return;
        }
        if (user.parent_id !== 0) {
            navigate('/not-allowed');
        }
    };

    /**
     * only comptable role can access this resource
     */
    const onlyComptable = () => {
        if (user.parent_id !== 0 && user.role !== COMPTABLE_ROLE_ID && user.role !== ALL_ACCESS_ROLE_ID) {
            navigate('/not-allowed');
        }
    }

    /**
     * only commercial role can access this resource
     */
    const onlyCommercial = () => {
        if (user.parent_id !== 0 && user.role !== COMMERCIAL_ROLE_ID && user.role !== ALL_ACCESS_ROLE_ID) {
            navigate('/not-allowed');
        }
    }
    const onlyMembres = () => {
        console.log("User role:", user?.role);
        console.log("COMMERCIAL_ROLE_ID:", COMMERCIAL_ROLE_ID);
        console.log("COMPTABLE_ROLE_ID:", COMPTABLE_ROLE_ID);
        if (user?.role || (user.role === COMMERCIAL_ROLE_ID || user.role === COMPTABLE_ROLE_ID)) {
          navigate('/factures_brouillons');
        }
      };
    
    const hadAddAccess = () => {
        if (user === undefined || user === null) {
            return false;
        }
        if (userAcces.had_add_access === true) {
            return true;
        }
        navigate('/not-allowed');
    }
    const hadEditAccess = () => {
        if (user === undefined || user === null) {
            return false;
        }
        if (userAcces.had_edit_access === true) {
            return true;
        }
        return false;
    }
    const hadDeleteAccess = () => {
        if (user === undefined || user === null) {
            return false;
        }
        if (userAcces.had_delete_access === true) {
            return true;
        }
        return false;
    }

    return {onlyAdmins,onlyComptable,onlyCommercial,onlyMembres,hadAddAccess,hadEditAccess,hadDeleteAccess};
};

export default useAuthHelper;
